import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [USER_ROLES.CSM, USER_ROLES.IMPLEMENTATION];

export default {
	SUBSCRIPTIONS: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'manage-subscriptions',
		LABEL: 'Subscriptions',
		ICON: 'interface-tag',
		PATH: '/subscriptions/:section',
		CHILDREN: ['SUBSCRIPTIONS_LIST', 'SUBSCRIPTIONS_DETAIL'],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},

	SUBSCRIPTIONS_LIST: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'manage-subscriptions-list',
		LABEL: 'Subscriptions List',
		PARAMS: {
			section: 'list',
		},
		PERMISSIONS,
	},
	SUBSCRIPTIONS_DETAIL: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'manage-subscriptions-detail',
		LABEL: 'Subscription Details',
		PARAMS: {
			section: ':subscriptionID',
		},
		PERMISSIONS,
	},
};
